import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-extract",
  "use": "icon-op-extract-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-extract\"><path d=\"M10 3h3c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1m0-1c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM4 5h1V3.5l2 2-2 2V6H4c-.3 0-.5.2-.5.5V9h-1V6.5C2.5 5.7 3.2 5 4 5m0 6v2H2v-2zm1-1H1v4h4zm4 1v2H7v-2zm1-1H6v4h4zm4 1v2h-2v-2zm1-1h-4v4h4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol